import { Directive, HostListener } from '@angular/core';

@Directive({
    selector: '[click-stop-propagation]',
    standalone: true
})
export class ClickStopPropagationDirective {
    @HostListener('click', ['$event'])
    onClick(event: any) {
        event.stopPropagation();
    }
}
